import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "basicLayout" }
const _hoisted_2 = {
  key: 0,
  class: "userContainer"
}
const _hoisted_3 = {
  key: 1,
  class: "container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalHeader = _resolveComponent("GlobalHeader")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_UserCenterView = _resolveComponent("UserCenterView")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { style: {"min-height":"100vh"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, { class: "header" }, {
          default: _withCtx(() => [
            _createVNode(_component_GlobalHeader)
          ]),
          _: 1
        }),
        (_ctx.route.path.startsWith('/center'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_a_layout_content, { class: "userCenterView" }, {
                default: _withCtx(() => [
                  _createVNode(_component_UserCenterView)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_a_layout_content, { class: "content" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ])),
        _createVNode(_component_a_layout_footer, { class: "footer" }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" My Online Judge")
          ])),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}